import { IncError } from "@core/domain/errors/inc.error";
import i18n from "@i18n";

export class PublicItineraryMapperError extends IncError {
    constructor() {
        super(i18n.t("error:beneficiary.publicItinerary.mapperError"));

        Object.setPrototypeOf(this, PublicItineraryMapperError.prototype);
    }
}